export const PRIVATE_INVOICE_NOTES_MESSAGE = "priceListPrivateInvoiceNotes";
const validId = value => typeof value === "string" && /^[A-Za-z0-9][A-Za-z0-9:_-]{0,127}$/.test(value);
const plain = value => value && Object.getPrototypeOf(value) === Object.prototype;
export const invoiceNotesScope = identity => JSON.stringify([identity.estimateId, identity.documentId]);
export function validInvoiceNotesEntries(entries) {
  return plain(entries) && Object.keys(entries).length <= 200 && Object.entries(entries).every(([id, entry]) =>
    validId(id) && plain(entry) && ["lineNote", "comment"].includes(entry.kind) && typeof entry.text === "string"
    && entry.text.trim() && entry.text.length <= 16000
    && Object.keys(entry).every(key => ["kind", "text", "lineId", "note"].includes(key))
    && (entry.kind === "lineNote" ? entry.lineId === id && !Object.prototype.hasOwnProperty.call(entry, "note")
      : !Object.prototype.hasOwnProperty.call(entry, "lineId") && typeof entry.note === "string" && (entry.text + entry.note).length <= 16000));
}
export function validateInvoiceNotesReceipt(receipt) {
  if (!receipt || receipt.invoiceNotesProtocol !== 1 || receipt.canRead !== true || typeof receipt.canEdit !== "boolean"
      || !Number.isSafeInteger(receipt.revision) || receipt.revision < 0 || !validInvoiceNotesEntries(receipt.entries)) {
    throw Object.assign(new Error("Private item notes could not be verified. Your draft is still here."), { code: "UNAVAILABLE" });
  }
  return receipt;
}
